import { render, staticRenderFns } from "./localtion.vue?vue&type=template&id=60878e45&"
var script = {}
import style0 from "./localtion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60878e45')) {
      api.createRecord('60878e45', component.options)
    } else {
      api.reload('60878e45', component.options)
    }
    module.hot.accept("./localtion.vue?vue&type=template&id=60878e45&", function () {
      api.rerender('60878e45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/localtion/localtion.vue"
export default component.exports